/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, Button as SemanticButton } from 'semantic-ui-react';

import {
  Button as ButtonLayout, Header as HeaderLayout, Loader as LoaderLayout, Text as TextLayout,
  colors,
} from '@playbookux/playbook-web-core';

const { WHITE } = colors;

export const TextPrimary = styled(TextLayout)``;

export const Message = styled(TextPrimary.Bold)`
  font-size: 22px;
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: center;
  max-width: 1200px;
  margin: 80px auto 0px auto;
`;

export const Centered = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px 0px !important;
`;

export const CardContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  max-width: 620px;
  padding: 20px;
  margin: 0px auto;
  border-radius: 5px;
  background: ${WHITE};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  margin-bottom: 25px
`;

Header.Left = styled.div`
  display: inherit;
  padding-right: 10px;
`;

Header.Center = styled.div`
  display: inherit;
  flex-direction: column;
  flex: 1;
`;

Header.PlatformContainer = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

Header.TestType = styled(TextPrimary)`
  margin-left: 5px;
`;

export const Amount = styled(HeaderLayout)`
  margin-top: 1px !important;
`;

export const Platform = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 15px;
`;

Platform.Icon = styled(Icon).attrs(({ platform, os }) => ({
  name: ['ios', 'macos'].includes(os) ? 'apple' : (platform === 'computer' ? 'windows' : 'android'),
  size: 'large',
  color: 'grey',
}))``;
Platform.Name = styled.p`
  padding-bottom: 0px !important;
  line-height: 25px;
`;

export const StudyPlatform = ({ platform, os }) => (
  <Platform>
    <Platform.Icon platform={platform} os={os} />
    {platform === 'computer' && os === 'macos' && <Platform.Name>Mac Computer</Platform.Name>}
    {platform === 'computer' && os === 'windows' && <Platform.Name>Windows Computer</Platform.Name>}
    {platform === 'smartphone' && os === 'ios' && <Platform.Name>iPhone</Platform.Name>}
    {platform === 'smartphone' && os === 'android' && <Platform.Name>Android Phone</Platform.Name>}
    {platform === 'tablet' && os === 'ios' && <Platform.Name>iPad</Platform.Name>}
    {platform === 'tablet' && os === 'android' && <Platform.Name>Android Tablet</Platform.Name>}
  </Platform>
);

StudyPlatform.propTypes = {
  platform: PropTypes.string.isRequired,
  os: PropTypes.string.isRequired,
};

export const TextContainer = styled.div`
  p {
    margin-bottom: 10px !important;
  }
`;

export const Footer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-evenly;
  margin-top: 15px;
`;

Footer.ButtonSecondary = styled(SemanticButton).attrs({
  compact: true,
  inverted: true,
  color: 'red',
})``;
Footer.ButtonPrimary = styled(ButtonLayout)``;

export const Loader = styled(LoaderLayout)`
  flex: 1;
`;
